module.exports = __webpack_public_path__ + "static/media/DZ.075bdf29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/DZ.svg
// module id = 242
// module chunks = 0